/* 🤖 this file was generated by script */
export const wiconMaximize02 = {
  name: 'maximize_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 3h-.2c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C3 5.29 3 6.13 3 7.8V8m5 13h-.2c-1.68 0-2.52 0-3.16-.33a3 3 0 01-1.31-1.3C3 18.71 3 17.87 3 16.2V16m18-8v-.2c0-1.68 0-2.52-.33-3.16a3 3 0 00-1.3-1.31C18.71 3 17.87 3 16.2 3H16m5 13v.2c0 1.68 0 2.52-.33 3.16a3 3 0 01-1.3 1.31c-.65.33-1.49.33-3.17.33H16"/></svg>`,
};
